import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Users, Shield, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const pillars = [{
    icon: <Users className="w-6 h-6 text-purple-700" data-id="element-281" />,
    title: 'Women Seeking Wellness',
    desc: 'Personalized, intelligent pathways tailored to individual needs.'
  }, {
    icon: <Shield className="w-6 h-6 text-purple-700" data-id="element-282" />,
    title: 'Verified Practitioners',
    desc: 'A trusted network of vetted, specialized care providers.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-purple-700" data-id="element-283" />,
    title: 'Premium Brands',
    desc: 'Curated wellness products and services that align with your journey.'
  }];
  return <Section background="ivory" className="bg-purple-100" data-id="element-284">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-285">
        <FadeIn data-id="element-286">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-287">
            A Curated Digital Wellness Marketplace
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-288">
            Fem Entity is a private, intelligent platform designed to unify the
            wellness experience for women.
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-289">
        {pillars.map((pillar, idx) => <FadeIn key={idx} delay={idx * 200} data-id="element-290">
            <div className="bg-white/80 backdrop-blur-sm border border-purple-200 p-8 rounded-2xl h-full transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-purple-200/30" data-id="element-291">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm" data-id="element-292">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-293">
                {pillar.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-294">{pillar.desc}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={600} data-id="element-295">
        <div className="glass-panel rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto" data-id="element-296">
          <h3 className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-8" data-id="element-297">
            Core Experience Layers
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-298">
            <div className="flex-1" data-id="element-299">
              <div className="text-xl font-serif text-charcoal mb-2" data-id="element-300">
                Discover
              </div>
              <div className="text-sm text-charcoal/60" data-id="element-301">
                Trusted practitioners & services
              </div>
            </div>
            <div className="hidden md:block w-8 h-[1px] bg-charcoal/20" data-id="element-302"></div>
            <div className="flex-1" data-id="element-303">
              <div className="text-xl font-serif text-charcoal mb-2" data-id="element-304">
                Personalize
              </div>
              <div className="text-sm text-charcoal/60" data-id="element-305">
                AI-guided wellness plans
              </div>
            </div>
            <div className="hidden md:block w-8 h-[1px] bg-charcoal/20" data-id="element-306"></div>
            <div className="flex-1" data-id="element-307">
              <div className="text-xl font-serif text-charcoal mb-2" data-id="element-308">
                Engage
              </div>
              <div className="text-sm text-charcoal/60" data-id="element-309">
                Book, track, and optimize
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}